import { render, staticRenderFns } from "./CreateNewFolder.vue?vue&type=template&id=ef7a6a58&scoped=true"
import script from "./CreateNewFolder.vue?vue&type=script&lang=js"
export * from "./CreateNewFolder.vue?vue&type=script&lang=js"
import style0 from "./CreateNewFolder.vue?vue&type=style&index=0&id=ef7a6a58&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef7a6a58",
  null
  
)

export default component.exports